/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { AppSessionUser } from '../domain/app-session-user.entity';

const INITIAL_STATE: AppUserState = {
  sessionUser: null,
  reloadUser: null,
};

export const NAMESPACE = 'APP-USER';

export const AppUserActions = {
  INIT: `${NAMESPACE}.INIT`,
  SET_SESSION_USER: `${NAMESPACE}.SET_SESSION_USER`,
  RELOAD_USER: `${NAMESPACE}.RELOAD_USER`,
  KEEP_CURRENT_STATE: `${NAMESPACE}.KEEP_CURRENT_STATE`,
};

export const AppUserReducer = (state: AppUserState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case AppUserActions.INIT:
      return { ...INITIAL_STATE };
    case AppUserActions.KEEP_CURRENT_STATE:
      return state;
    case AppUserActions.RELOAD_USER:
      return {
        ...state,
        reloadUser: action.payload
      };
    case AppUserActions.SET_SESSION_USER:
      return {
        ...state,
        sessionUser: action.payload,
      };
    default:
      return state;
  }
};

export interface AppUserState {
  sessionUser: AppSessionUser;
  reloadUser: boolean;
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
